import React from 'react';

const Strong = props => <strong {...props} />;

export default Strong;



// WEBPACK FOOTER //
// ./src/components/atoms/Strong/Strong.js